/* JOY curated cart complements. Theme-scoped; no global product writes.
 * Catalog audited 2026-10-03. Unknown hardware gets no substitute recommendation.
 * Product handles identify actual catalog records; stock and price are rendered by Shopify.
 */
(() => {
  'use strict';
  const K = {
    wipes: 'staleks-ws-400', brush: 'staleks-nbe-04', liner: 'staleks-nbe-01',
    dust: 'staleks-dbe-01', tray: 'staleks-le-10-1', bitTray: 'staleks-le-20-1',
    oil: 'staleks-not-10', pusher: 'staleks-pe-30-1', magnet: 'lunamoon-182-5736'
  };
  const brands = {
    DNKA: {top: ['dnka-fttnwd12nuv', 'dnka-ftmtnwd12'], milk: 'dnka-fttmid12', brush: ['dnka-gbdnka', 'dnka-lgbdnka', K.brush], liner: ['dnka-lbdnka-8', 'dnka-lbdnka-11'], poly: ['dnka-pbdnka'], wipes: ['dnka-pw-200', K.wipes], oil: ['dnka-cofsdnka', 'dnka-coggdnka'], cream: ['dnka-hlbdnka']},
    LUNAMOON: {top: ['lunamoon-300-0301', 'lunamoon-300-3640'], brush: ['lunamoon-lunamoon-double-sided-brush'], liner: ['lunamoon-lunamoon-double-sided-brush'], wipes: [K.wipes], oil: ['lunamoon-325-2755'], cream: ['lunamoon-325-5074-1441']},
    YOUARECUTE: {top: ['youarecute-992-4059-1001', 'youarecute-992-4059-1673'], brush: [K.brush], liner: [K.liner], wipes: [K.wipes], oil: [K.oil]},
    TOUCH: {top: ['touch-top-no-wipe-13ml-800040', 'touch-top-non-uv-13ml-800064'], milk: 'touch-cover-top-milky-13ml-800194', brush: ['touch-brush-gel-nail-5mm-802570', 'touch-double-sided-nail-gel-brush-802594'], liner: ['touch-brush-nail-liner-9mm-802587'], wipes: [K.wipes], oil: [K.oil]},
    KINETICS: {top: ['max-top-light-15ml-ktc05', 'kinetics-shield-max-top-15ml-ktc03'], milk: 'kinetics-shield-nude-top-stone-939-15ml-knt939', brush: [K.brush], liner: [K.liner], wipes: [K.wipes], oil: ['kinetics-almond-cuticle-oil-15ml-packed-in-box-ktr02b'], cream: ['kinetics-manicure-spa-pro-moisturizer-250ml-ksmrm08']}
  };
  const gelTypes = new Set(['BASE', 'GEL POLISH', 'BUILDER GEL', 'HARD GEL', 'JELLY GEL', 'CLASSIC GEL', 'BOTTLE GEL', 'GEL IN BOTTLE', 'LIQUID BUILDER GEL', 'ACRYGEL', 'POLYGEL']);
  const artTypes = new Set(['GEL PAINT', 'GEL PASTE', 'GLITTER GEL', 'METAL GEL', 'LIQUID GLITTER', 'DRY GLITTER', 'NAIL POWDER']);
  const prepTypes = new Set(['PREP', 'CLEANSER', 'PRIMER', 'BONDER', 'DEHYDRATOR', 'LIQUIDS', 'REMOVER']);
  const careTypes = new Set(['CUTICLE OIL', 'CUTICLE CARE', 'NAIL & CUTICLE CARE', 'NAIL CARE']);
  const basePairs = {
    'staleks-mbe-20': ['staleks-dfce-20-180-25w', 'staleks-dfce-22-180w'],
    'staleks-spbe-20': ['staleks-dfce-20-180-25w', 'staleks-dfce-22-180w'],
    'staleks-wbe-20': ['staleks-dfce-20-180-25w'],
    'staleks-mbe-20s': ['staleks-dfc-20-180'],
    'staleks-spbe-20s': ['staleks-dfc-20-180'],
    'staleks-mbe-50': ['staleks-dfe-51-180w', 'staleks-dfe-51-240w'],
    'staleks-spbe-50': ['staleks-dfe-51-180w', 'staleks-dfe-51-240w'],
    'staleks-mbe-40': ['staleks-dfe-40-180w', 'staleks-dfe-42-180w'],
    'staleks-mbe-10': ['staleks-dfe-10-180w', 'staleks-dfe-10-100w']
  };
  const get = (item) => ({
    handle: String(item.handle || item.product?.handle || '').toLowerCase(),
    title: String(item.product_title || item.title || item.product?.title || ''),
    type: String(item.product_type || item.productType || item.product?.type || '').toUpperCase(),
    brand: String(item.vendor || item.product?.vendor || '').toUpperCase(),
    sku: String(item.sku || '').toUpperCase()
  });
  function refillBase(h) {
    if (/^staleks-(dfce|dfcemix|dfe|dfc)-(20|22)-/.test(h) || /^staleks-(atc|atsc|at|ats)-/.test(h)) return 'staleks-mbe-20';
    if (/^staleks-dfe[b]?-(51)-/.test(h)) return 'staleks-mbe-50';
    if (/^staleks-dfe-(40|42)-/.test(h)) return 'staleks-mbe-40';
    if (/^staleks-dfe-10-/.test(h)) return 'staleks-mbe-10';
    return null;
  }
  function ownedKeys(raw) {
    const p = get(raw), h = p.handle, t = p.title.toLowerCase(), keys = [];
    if (p.type === 'TOP') keys.push(h.includes('solargel') ? 'top:solar' : `top:${p.brand}`);
    if (p.type === 'WIPES') keys.push('wipes');
    if (careTypes.has(p.type)) keys.push('oil');
    if (p.type === 'HAND CARE' || (p.type === 'CARE' && /hand/.test(t))) keys.push('hand-cream');
    if (p.type === 'FOOT CARE') keys.push('foot-cream');
    if (/staubbürsten|dust brushes/i.test(p.type)) keys.push('dust');
    if (h === K.tray) keys.push('tray');
    if (h === K.bitTray) keys.push('bit-tray');
    if (/^staleks-hpq-/.test(h)) keys.push('combo-handle');
    if (/^staleks-wppq-(16|17)$/.test(h)) keys.push('combo-pusher');
    if (h === 'staleks-wppq-13') keys.push('combo-cleaner');
    if (p.type === 'PUSHERS & CURETTES' && !/combo|curette|kürette|pedicure|pediküre|podology/i.test(t) && !/^staleks-(hpq|wppq)-/.test(h)) keys.push('pusher');
    if (/magnet/i.test(t) && ['TOOLS', 'NAIL BRUSHES', 'BRUSH'].includes(p.type)) keys.push('magnet');
    if (['BRUSH', 'NAIL BRUSHES', 'TOOLS'].includes(p.type) && /pinsel|brush/i.test(t)) {
      if (/gel|doppelseitig|double.sided|dual.sided/i.test(t) && !/polygel/i.test(t)) keys.push('gel-brush');
      if (/liner|doppelseitig|double.sided|dual.sided/i.test(t)) keys.push('liner');
      if (/polygel/i.test(t)) keys.push('poly-brush');
    }
    const disc = h.match(/^staleks-pd(?:l)?set-(10|15|20|25)$/);
    const refill = h.match(/^staleks-pdf(?:s|b)?-(10|15|20|25)(?:-|$)/);
    if (disc) keys.push(`podo-base:${disc[1]}`);
    if (refill) keys.push(`podo-refill:${refill[1]}`);
    if (basePairs[h]) keys.push(`file-base:${h}`);
    if (refillBase(h)) keys.push(`file-refill:${refillBase(h)}`);
    if (p.type === 'STERILIZATION POUCH') keys.push('heat-pouch');
    if (['staleks-se-30-1','staleks-se-90-2'].includes(h)) keys.push('brow-scissors');
    return keys;
  }
  function forProduct(raw) {
    const p = get(raw), h = p.handle, t = p.title.toLowerCase(), b = brands[p.brand], out = [];
    const add = (key, priority, handles, reason) => {
      if (!handles?.length) return;
      out.push({key, priority, source: p.title, sourceHandle: h, targets: handles.map(handle => ({handle, reason}))});
    };
    const wipes = (rank = 65) => add('wipes', rank, b?.wipes || [K.wipes], 'wipes');
    const oil = (rank = 55) => add('oil', rank, b?.oil || [K.oil], 'oil');
    const brush = (rank = 25) => add('gel-brush', rank, b?.brush || [K.brush], 'gel-brush');
    const liner = () => add('liner', 30, b?.liner || [K.liner], 'liner');
    if (!h || raw.gift_card || raw.selling_plan_allocation || /baby|for kids|für kinder|0\+/.test(t)) return out;
    // Model/size rules run before potentially inaccurate merchant product types.
    const disc = h.match(/^staleks-pd(?:l)?set-(10|15|20|25)$/);
    const refill = h.match(/^staleks-pdf(?:s|b)?-(10|15|20|25)(?:-|$)/);
    if (disc) {
      const s = disc[1];
      add(`podo-refill:${s}`, 5, [`staleks-pdf-${s}-180w`, `staleks-pdf-${s}-240w`], `podo-refill:${s}`);
      return out;
    }
    if (refill) {
      const s = refill[1];
      add(`podo-base:${s}`, 5, [`staleks-pdset-${s}`, `staleks-pdlset-${s}`], `podo-base:${s}`);
      return out;
    }
    if (basePairs[h]) {
      add(`file-refill:${h.replace('spbe', 'mbe').replace('wbe', 'mbe')}`, 5, basePairs[h], 'file-refill');
      out[0].compatibleRefillBase = h;
      add('dust', 55, [K.dust], 'dust');
      return out;
    }
    const matchingBase = refillBase(h);
    if (matchingBase) {
      add(`file-base:${matchingBase}`, 5, [matchingBase], 'file-base');
      let compatible = [matchingBase];
      if (/^staleks-(dfc-20-|atc-|atsc-)/.test(h)) compatible = ['staleks-mbe-20','staleks-mbe-20s','staleks-spbe-20','staleks-spbe-20s','staleks-wbe-20'];
      else if (/^staleks-dfce-20-/.test(h)) compatible = ['staleks-mbe-20','staleks-spbe-20','staleks-wbe-20'];
      else if (/^staleks-(dfce|dfcemix|dfe|dfc)-(20|22)-/.test(h)) compatible = ['staleks-mbe-20','staleks-spbe-20'];
      else if (matchingBase === 'staleks-mbe-50') compatible.push('staleks-spbe-50');
      out[0].compatibleOwners = compatible;
      return out;
    }
    if (/^staleks-hpq-10b?$/.test(h)) {
      add('combo-pusher', 5, ['staleks-wppq-16', 'staleks-wppq-17'], 'combo-pusher');
      add('combo-cleaner', 6, ['staleks-wppq-13'], 'combo-cleaner');
      return out;
    }
    if (/^staleks-wppq-(11y|12y|13|14|16|17|18|19)$/.test(h)) {
      add('combo-handle', 5, ['staleks-hpq-10', 'staleks-hpq-10b'], 'combo-handle');
      return out;
    }
    if (p.brand === 'MICROSTOP') {
      if (/^microstop-dry-heat-sterilizer-(compact|optimal|maxi)$/.test(h)) {
        add('heat-pouch', 5, ['microstop-sterilization-pouch-white-100x200-mm-100-pcs', 'microstop-sterilization-pouch-eco-100x200-mm-100-pcs'], 'heat-pouch');
      }
      // No validated HEPA replacements, lamp parts or ultrasound liquids in this catalog.
      return out;
    }
    if (['LED LAMP', 'DUST COLLECTOR', 'ULTRASONIC CLEANER', 'STERILIZER', 'DISINFECTION CONTAINER', 'STERILIZATION POUCH'].includes(p.type)) return out;
    if (p.brand === 'KINETICS' && p.type === 'NAIL POLISH') {
      add('top:solar', 10, ['kinetics-solargel-top-coat-15ml-kdtc'], 'solar-top');
      oil(); return out;
    }
    if (p.brand === 'TOUCH' && (/one[ -]?step/.test(t) || /-one-step-/.test(h))) { wipes(30); oil(); return out; }
    if (b && gelTypes.has(p.type)) {
      const milky = /\bmilk(y)?\b|milch/.test(t);
      const targets = b.top.map(handle => ({handle, reason: 'top'}));
      if (milky && b.milk) targets.unshift({handle: b.milk, reason: 'milk-top'});
      out.push({key: `top:${p.brand}`, priority: 10, targets, source: p.title, sourceHandle: h});
      if (/cat(?:['’`]?s)?[ -]*eye/.test(t)) add('magnet', 8, [K.magnet], 'magnet');
      if (p.type === 'ACRYGEL' && b.poly) add('poly-brush', 20, b.poly, 'poly-brush');
      else if (!['BASE', 'GEL POLISH', 'LIQUID BUILDER GEL', 'BOTTLE GEL', 'GEL IN BOTTLE'].includes(p.type) && !/liquid polygel/.test(t)) brush();
      wipes(); return out;
    }
    if (b && artTypes.has(p.type)) { liner(); wipes(); return out; }
    if (p.type === 'TOP' && b) {
      if (h === 'kinetics-shield-shine-top-15ml-ktc01') add('cleanser', 15, ['kinetics-cleanser-225ml-kcl08'], 'cleanser');
      oil(25); wipes(); return out;
    }
    if (b && prepTypes.has(p.type)) { wipes(20); return out; }
    if (['NAIL FORMS', 'DUAL FORMS', 'NAIL TIPS', 'TIPS'].includes(p.type) && b) {
      // No unverified adhesive/base is prescribed for full-cover tips.
      if (/obere|upper|modell|dual/.test(t) || p.type === 'NAIL FORMS') brush(20);
      wipes(45); return out;
    }
    if (p.brand === 'SHELLY') {
      if (p.type === 'HAND CARE') add('oil', 25, ['shelly-3-735052', 'shelly-30-735031'], 'oil');
      else if (careTypes.has(p.type) && !/farnesol|eingewachsen|antibakter|schutzwirkung|salbe/.test(t)) add('hand-cream', 25, ['shelly-45-735016'], 'hand-cream');
      else if (p.type === 'SKIN CARE' && /peeling|badesalz/.test(t) && !/aha/.test(h)) add('hand-cream', 25, ['shelly-45-735016'], 'hand-cream');
      // Specialized podology treatments and pre-filled kits need separate clinical/use checks.
      return out;
    }
    if (b && p.type === 'HAND CARE') { oil(25); return out; }
    if (b && careTypes.has(p.type)) { add('hand-cream', 25, b.cream, 'hand-cream'); return out; }
    if (p.brand === 'KINETICS' && p.type === 'MANICURE SPA') {
      if (!h.includes('moisturizer')) add('hand-cream', 25, ['kinetics-manicure-spa-pro-moisturizer-250ml-ksmrm08'], 'hand-cream');
      else oil(30);
      return out;
    }
    if (['BRUSH', 'NAIL BRUSHES'].includes(p.type) || (p.type === 'TOOLS' && /pinsel|brush/.test(t))) { wipes(35); return out; }
    if (p.brand === 'STALEKS') {
      if (h === K.bitTray || h === K.tray || h === 'staleks-tedf-10-1') return out;
      if (p.type === 'DRILL BITS' || p.type === 'DIAMANTFRÄSER') { add('bit-tray', 20, [K.bitTray], 'bit-tray'); return out; }
      if (p.type === 'FILE REFILLS' || p.type === 'PODO DISC REFILLS' || p.type === 'NAIL FILE BASES') return out;
      if (p.type === 'EYEBROW TWEEZERS') { add('brow-scissors', 25, ['staleks-se-30-1', 'staleks-se-90-2'], 'brow-scissors'); return out; }
      if (p.type === 'EYELASH TOOLS' || p.type === 'COSMETOLOGY TOOLS' || /podology|podo |eingewachsen|ingrown|curette|kürette/.test(t)) { add('tray', 30, [K.tray], 'tray'); return out; }
      if (['SCISSORS', 'NAGELHAUTSCHEREN', 'NIPPERS'].includes(p.type) && /nagelhaut|cuticle/.test(t)) {
        add('pusher', 25, [K.pusher], 'pusher'); oil(45); add('tray', 50, [K.tray], 'tray'); return out;
      }
      if (p.type === 'PUSHERS & CURETTES') { oil(30); add('tray', 40, [K.tray], 'tray'); return out; }
      if (p.type === 'NAIL FILES & BUFFERS' || h === 'staleks-nfs-30') { add('dust', 25, [K.dust], 'dust'); oil(45); return out; }
      if (['ORANGE STICKS', 'ORANGENHOLZSTÄBCHEN', 'STAUBBÜRSTEN', 'DUST BRUSHES'].includes(p.type)) { oil(35); return out; }
    }
    // Standalone merchandise, unknown systems and already-complete kits: no filler.
    return out;
  }
  function plan(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const inCart = new Set(items.map(item => get(item).handle));
    const owned = new Set(items.flatMap(ownedKeys));
    const groups = new Map();
    items.forEach((item, order) => forProduct(item).forEach(rec => {
      if (owned.has(rec.key) || rec.compatibleOwners?.some(handle => inCart.has(handle))) return;
      if (rec.compatibleRefillBase && items.some(other => forProduct(other).some(candidate => candidate.compatibleOwners?.includes(rec.compatibleRefillBase)))) return;
      rec.targets = rec.targets.filter(target => !inCart.has(target.handle));
      if (!rec.targets.length) return;
      rec.order = order;
      const previous = groups.get(rec.key);
      if (!previous || rec.priority < previous.priority) groups.set(rec.key, rec);
    }));
    return [...groups.values()].sort((a, b) => a.priority - b.priority || a.order - b.order).slice(0, 6);
  }
  const api = Object.freeze({plan, forProduct, ownedKeys, version: '20261003-hyper150-2'});
  if (typeof module === 'object' && module.exports) module.exports = api;
  else window.JoyCrossSellRules = api;
})();
